import React from 'react';
import Link from '../link';

const Breadcrumb: React.FC = () => (
  <div className="breadcrumb">
    <Link href={`/`}>
      <a>
        <i className="fas fa-long-arrow-alt-left" /> Back to home
      </a>
    </Link>
    {/* language=CSS */}
    <style jsx>{`
      :global(html) {
        scroll-behavior: smooth;
      }

      .breadcrumb {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        margin: 1rem 0;
        padding: 0rem 3rem;
        text-align: left;
        position: fixed;
        z-index: 100;
      }

      .breadcrumb a {
        color: var(--text-primary);
        text-decoration: none;
        transition: all 0.2s linear;
      }

      .breadcrumb a:hover {
        color: var(--interactive-primary);
      }

      @media screen and (max-width: 1350px) {
        .breadcrumb {
          margin-bottom: 0;
          margin-top: 1rem;
          position: relative;
        }
      }
    `}</style>
  </div>
);

export default Breadcrumb;
